import { getQueryParams } from '@/utils/utils';

// 接口权限场景标识
const SCENE_ENUM = {
  INVOCIE: 'invoice',
  FINANCE: 'finance',
  EXPENSE: 'expense',
  OPERATION: 'operation',
  CASHIER: 'cashier', // 单据融合改造用到
};

// 场景菜单枚举
const SCENE_URL = {
  '/cashier/list': SCENE_ENUM.FINANCE, // 财务管理-出纳结算
  '/cashier/replenish-invoice': SCENE_ENUM.FINANCE, // 财务管理-发票补充
  '/invoice/index': SCENE_ENUM.FINANCE, // 财务管理-发票管理
  '/finance-invoice-list/index': SCENE_ENUM.FINANCE, // 财务管理-单据查询
  '/bank/receipt/list': SCENE_ENUM.FINANCE, // 财务管理-银行回单
  '/finance-invoice-list/history': SCENE_ENUM.FINANCE, // 财务管理-历史单据
  '/company/event-manage/list': SCENE_ENUM.FINANCE, // 单位侧的事件管理使用财务的权限
  '/cashier-document/list': SCENE_ENUM.FINANCE, // 财务管理-出纳结算（单据融合）
  '/finance-document/list': SCENE_ENUM.FINANCE, // 财务管理-单据查询（单据融合）
  '/history-document/list': SCENE_ENUM.FINANCE, // 财务管理-单据查询（单据融合）
  '/overtime-manage/list': SCENE_ENUM.FINANCE, // 夜餐费明细 - 查看申请单
  '/attendance/department': SCENE_ENUM.FINANCE, // 部门考勤 - 查看申请单
  '/accounting/voucher': SCENE_ENUM.FINANCE, // 记账凭证 - 查看单据
  '/intercourse-funds': SCENE_ENUM.FINANCE, // 往来款查看单据详情
  '/rental-settlement/list': SCENE_ENUM.FINANCE, // 车辆报销-查看单据
  '/depart-schedule': SCENE_ENUM.FINANCE, // 部门出差日历
  '/car-manage/list': SCENE_ENUM.FINANCE, // 车辆管理
  '/small-entrust/collection-deduction-voucher': SCENE_ENUM.FINANCE, // 小额托收-扣款凭证
  '/small-entrust/carry-over-payment': SCENE_ENUM.FINANCE, // 小额托收-托收结转
  '/small-entrust/summaryList': SCENE_ENUM.FINANCE, // 小额托收【新】-汇总列表

  '/apply-manage/index': SCENE_ENUM.EXPENSE, // 支出管理-我的申请
  '/claim-manage/index': SCENE_ENUM.EXPENSE, // 支出管理-我的报销
  '/pending/apply': SCENE_ENUM.EXPENSE, // 支出管理-审批 申请单
  '/pending/claim': SCENE_ENUM.EXPENSE, // 支出管理-审批 报销单
  '/pending-audit/claim': SCENE_ENUM.EXPENSE, // 支出管理-审批 报销单
  '/pending-audit/apply': SCENE_ENUM.EXPENSE, // 支出管理-审批 报销单
  '/order-list': SCENE_ENUM.EXPENSE, // 支出管理-我的订单
  '/relation/my-all': SCENE_ENUM.EXPENSE, // 支出管理-我的报销-全部单据
  '/my-document/list': SCENE_ENUM.EXPENSE, // 支出管理-我的单据（单据融合）
  '/all-my-document/list': SCENE_ENUM.EXPENSE, // 支出管理-我的全部单据（单据融合）
  '/approval-document/list': SCENE_ENUM.EXPENSE, // 支出管理-我的审批（单据融合）

  '/note-manage/index': SCENE_ENUM.INVOCIE, // 支出管理-我的发票

  '/invoice-list/index': SCENE_ENUM.OPERATION, // 运营机构-单据查询
  '/invoice-manage': SCENE_ENUM.OPERATION, // 运营机构-票据
  '/abnormal-document/list': SCENE_ENUM.OPERATION, // 运营机构-外部单据
  '/operation/event-manage/list': SCENE_ENUM.OPERATION, // 运营机构-事件管理列表
  '/zoning-backstage/event-manage/list': SCENE_ENUM.OPERATION, // 运营机构-事件管理列表
  '/zoning-backstage/invoice-manage': SCENE_ENUM.OPERATION, // 租户管理-运营管理-单据查询
  '/operation-document/list': SCENE_ENUM.OPERATION, // 运营机构-单据查询（单据融合）
  '/reimburse-document/list': SCENE_ENUM.FINANCE,
  '/business-trip/index': SCENE_ENUM.FINANCE, // 差旅看板
  '/totalBudget/formBudgetQuery': SCENE_ENUM.FINANCE, // 预算明细查询
};

// 申请单详情
const applyInfoInterface = {
  [SCENE_ENUM.EXPENSE]: '/zlb/api/expense/apply-form/query',
  [SCENE_ENUM.FINANCE]: '/zlb/api/expense/apply-form/institution/query-cashier',
  [SCENE_ENUM.OPERATION]: '/zlb/api/expense/operator/apply-form/query',
};

// 报销单详情
const claimInfoInterface = {
  [SCENE_ENUM.EXPENSE]: '/zlb/api/expense/expense-form/info',
  [SCENE_ENUM.FINANCE]: '/zlb/api/expense/expense-form/getInfoOnCashier',
  [SCENE_ENUM.OPERATION]: '/zlb/api/expense/operator/expense-form/query',
};

// 发票详情
const invoiceDetailInterface = {
  [SCENE_ENUM.INVOCIE]: '/zlb/api/invoice/detail-new',
  [SCENE_ENUM.EXPENSE]: '/zlb/api/expense/form/invoice-info',
  [SCENE_ENUM.FINANCE]: '/zlb/api/invoice/finance/detail',
  [SCENE_ENUM.OPERATION]: '/zlb/api/invoice/operation/detail',
};

export const getUrl = () => {
  let str = window.location.pathname;
  const arr = ['/main', '/claim', '/operator'];
  arr?.forEach(i => {
    str = str.replace(i, '');
  });
  return str;
};

// 获取url里的scene标识
export const getUrlScene = () => {
  const urlParams = location.href?.split('?');
  if (urlParams[1]) {
    const queryParams = getQueryParams(urlParams[1]);

    return queryParams.scene || '';
  }
  return '';
};

// 获取申请单详情接口
export const getAppyDetailInterface = params => {
  const { identity = '' } = params || {};
  let defaultInterface = applyInfoInterface[SCENE_ENUM.EXPENSE];
  if (window.location.href.includes('purchase') && identity === 'special') {
    defaultInterface = applyInfoInterface[SCENE_ENUM.FINANCE];
  }
  const url = getUrl();
  if (!url) return defaultInterface;
  const scene = SCENE_URL[url];
  if (!scene) return defaultInterface;
  return applyInfoInterface[scene] || defaultInterface;
};

// 获取报销单详情接口
export const getClaimDetailInterface = params => {
  const { identity = '' } = params || {};
  let defaultInterface = claimInfoInterface[SCENE_ENUM.EXPENSE];
  if (window.location.href.includes('purchase') && identity === 'special') {
    defaultInterface = claimInfoInterface[SCENE_ENUM.FINANCE];
  }
  const url = getUrl();
  if (!url) return defaultInterface;
  const scene = SCENE_URL[url];
  if (!scene) return defaultInterface;
  return claimInfoInterface[scene] || defaultInterface;
};

// 获取发票详情接口
export const getInvociceDetailInterface = (returnDefault = false) => {
  const defaultInterface = invoiceDetailInterface[SCENE_ENUM.INVOCIE];
  const url = getUrl();
  if (!url || returnDefault) return defaultInterface;
  const scene = SCENE_URL[url];
  if (!scene) return defaultInterface;
  return invoiceDetailInterface[scene] || defaultInterface;
};
export default SCENE_ENUM;
